import { createRouter, createWebHistory } from "vue-router";
import App from "@/App.vue";

const routes = [{ path: "/", component: App }];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

router.beforeEach((to, from, next) => {
  const qp = to.query.url;

  if (qp === "lessonslearned") {
    // Break out of iframe and redirect the entire tab
    if (window.top) {
      window.top.location.href = "https://ai.u3t.abb.com/LL";
    }
    return; // Stop Vue navigation
  }

  next(); // Normal navigation stays within the iframe
});

export default router;
